export default __webpack_public_path__ + "static/media/ic-transmgt-black.4a3bc17d.svg";